import { Component, OnInit, OnDestroy, ViewChild, PLATFORM_ID, ChangeDetectionStrategy, ChangeDetectorRef, ViewContainerRef } from '@angular/core';
import { DomSanitizer, Title, Meta } from '@angular/platform-browser';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Wiki } from './wiki.model';
import { WikiService } from './wiki.service';
import { NavigationService } from '../shared/navigation/navigation.service';
import { Subscription, fromEvent } from 'rxjs';
import { distinctUntilChanged, map, debounceTime, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-wiki-details',
  templateUrl: 'wiki-details.component.html',
  styleUrls: ['wiki-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class WikiDetailsComponent implements OnInit, OnDestroy {

  public cdn = environment.cdn;
  public path: string;
  public pageTitle: string;
  public pageContent: string;
  public wiki: Wiki;
  public wikiContent: any[] = [];
  public path_list = '/';
  public path_details = '/';
  public stickTop = 0;

  constructor(private route: ActivatedRoute, private router: Router, private navigationService: NavigationService, private wikiService: WikiService, private cdr: ChangeDetectorRef) {
    // this.path_details = this.router.config.find(r => r.data?.module === 'WikiDetailsModule')?.data.path || '/';  
    this.path_list = this.router.config.filter(r => r?.data?.module === 'WikiModule').reduce((prev, curr) => (prev.data.level < curr.data.level) ? prev : curr)?.path || '/';
    const wikis = this.router.config.filter(x => x.data?.template == 'wiki');
    if (wikis.length) {
      this.path_details = wikis[wikis.length-1].data?.path || '/';
    }
  }

  ngOnInit() {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.path = params.get('path');
      this.wiki = null;
      this.wikiContent = [];
      this.loadData();
    });
    this.pageTitle = this.route.snapshot.data.name;
    this.pageContent = this.route.snapshot.data.content;
  }

  loadData() {
    this.wikiService.item(this.path).pipe(take(1)).subscribe(wiki => {
      this.wiki = wiki;
      if (this.wiki.photos) {
        const banner = this.wiki.photos.find(f => f.banner == 1);
        if (banner) this.wiki.banner = this.cdn+'/wikis/'+wiki.photos_directory+'/'+banner.filename
      }

      let fbimage;
      if (this.wiki.photos) {
        fbimage = this.wiki.photos.find(f => f.logo == 1);
      }

      if (this.wiki.categories) {
        let inner_category = this.wiki.categories.map(x => x.path).join('/');
        this.navigationService.setMeta(
          (this.wiki.meta_title ? this.wiki.meta_title : this.wiki.name),
          (this.wiki.meta_keywords ? this.wiki.meta_keywords : this.wiki.name),
          (this.wiki.meta_description ? this.wiki.meta_description : this.wiki.name),
          environment.base + '/' + this.path_details + '/' + inner_category + '/' + this.wiki.path,
          (fbimage ? this.cdn+'/wikis/'+wiki.photos_directory+'/'+fbimage.filename : null)
        );
        this.navigationService.currentPage.next(wiki);
      }
      this.cdr.detectChanges();
    }, error => {
      if (error.status === 404) {
        this.router.navigate(['404']);
      } else {
        // console.log(error);
      }
    });
  }

  changeModel(data) {
    this.wiki[data.field] = data.value;
  }

  ngOnDestroy() {
    console.log('destroy')
  }

}
